import "./loadingPage.css";

const LoadingPage = () => {
    return (
        <div className="LoadingPage">
            <div className="LoadingPage-contenedor">
                <div className="LoadingPage-contenedorMensaje mascara">
                </div>
            </div>
        </div>
    )
}

export default LoadingPage;